class ProductGallery {
  constructor() {
    this.init();
  }

  init() {
    // Initialize Swiper for default slider
    this.initDefaultSlider();
    
    // Initialize carousel with thumbnails
    this.initCarouselWithThumbnails();
    
    // Initialize masonry layout
    this.initMasonryLayout();
  }

  initDefaultSlider() {
    const defaultSliders = document.querySelectorAll('.gallery-style-slider .swiper');
    
    defaultSliders.forEach(slider => {
      new Swiper(slider, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
        },
        keyboard: {
          enabled: true,
        },
        a11y: {
          prevSlideMessage: 'Previous image',
          nextSlideMessage: 'Next image',
          firstSlideMessage: 'This is the first image',
          lastSlideMessage: 'This is the last image',
        }
      });
    });
  }

  initCarouselWithThumbnails() {
    const carouselContainers = document.querySelectorAll('.gallery-style-carousel');
    
    carouselContainers.forEach(container => {
      const mainCarousel = container.querySelector('.main-carousel');
      const thumbnailGallery = container.querySelector('.thumbnail-gallery');
      
      if (!mainCarousel || !thumbnailGallery) {
        console.log('ProductGallery: Missing carousel elements', { mainCarousel, thumbnailGallery });
        return;
      }

      // Check if Swiper is available
      if (typeof Swiper === 'undefined') {
        console.error('ProductGallery: Swiper library not loaded');
        return;
      }

      console.log('ProductGallery: Initializing carousel with thumbnails');

      // Initialize main carousel
      const mainSwiper = new Swiper(mainCarousel, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: mainCarousel.querySelector('.swiper-button-next'),
          prevEl: mainCarousel.querySelector('.swiper-button-prev'),
        },
        keyboard: {
          enabled: true,
        },
        a11y: {
          prevSlideMessage: 'Previous image',
          nextSlideMessage: 'Next image',
          firstSlideMessage: 'This is the first image',
          lastSlideMessage: 'This is the last image',
        }
      });

      const setActiveThumb = (index) => {
        console.log('ProductGallery: Setting active thumb to index:', index);
        const thumbnails = thumbnailGallery.querySelectorAll('.thumbnail-item');
        thumbnails.forEach(thumb => thumb.classList.remove('active'));
        const active = thumbnails[index];
        if (active) {
          console.log('ProductGallery: Found active thumbnail, scrolling into view');
          active.classList.add('active');
          // Scroll the thumbnail gallery to keep active thumbnail visible
          this.scrollThumbnailIntoView(active, thumbnailGallery);
        } else {
          console.log('ProductGallery: No thumbnail found at index:', index);
        }
      };

      // Initial active state
      setActiveThumb(mainSwiper.activeIndex || 0);

      // Sync main carousel with thumbnail gallery
      mainSwiper.on('slideChange', function () {
        console.log('ProductGallery: Slide changed to index', mainSwiper.activeIndex);
        setActiveThumb(mainSwiper.activeIndex);
      });

      // Add click handlers to thumbnails
      const thumbnailItems = thumbnailGallery.querySelectorAll('.thumbnail-item');
      console.log('ProductGallery: Found', thumbnailItems.length, 'thumbnail items');
      
      thumbnailItems.forEach((item, index) => {
        item.addEventListener('click', () => {
          console.log('ProductGallery: Thumbnail clicked, index:', index);
          mainSwiper.slideTo(index);
          setActiveThumb(index);
        });
      });
    });
  }

  initMasonryLayout() {
    const masonryContainers = document.querySelectorAll('.gallery-style-masonry');
    
    masonryContainers.forEach(container => {
      const masonryItems = container.querySelectorAll('.masonry-item');
      
      // Add staggered animation
      masonryItems.forEach((item, index) => {
        item.style.animationDelay = `${index * 0.1}s`;
        item.classList.add('masonry-animate');
      });

      // Recalculate layout on window resize
      window.addEventListener('resize', () => {
        this.recalculateMasonry(container);
      });
    });
  }

  recalculateMasonry(container) {
    // Force reflow for masonry layout
    const masonry = container.querySelector('.gallery-masonry');
    if (masonry) {
      masonry.style.display = 'none';
      setTimeout(() => {
        masonry.style.display = 'block';
      }, 10);
    }
  }

  scrollThumbnailIntoView(activeThumbnail, thumbnailGallery) {
    if (!activeThumbnail || !thumbnailGallery) return;

    const galleryRect = thumbnailGallery.getBoundingClientRect();
    const thumbnailRect = activeThumbnail.getBoundingClientRect();
    
    // Calculate the position of the thumbnail relative to the gallery container
    const thumbnailLeft = activeThumbnail.offsetLeft;
    const thumbnailWidth = activeThumbnail.offsetWidth;
    const galleryWidth = thumbnailGallery.offsetWidth;
    const currentScrollLeft = thumbnailGallery.scrollLeft;
    
    // Calculate the ideal scroll position to center the active thumbnail
    const idealScrollLeft = thumbnailLeft - (galleryWidth / 2) + (thumbnailWidth / 2);
    
    // Ensure the scroll position is within bounds
    const maxScrollLeft = thumbnailGallery.scrollWidth - galleryWidth;
    const targetScrollLeft = Math.max(0, Math.min(idealScrollLeft, maxScrollLeft));
    
    // Only scroll if the thumbnail is not fully visible
    const isVisible = thumbnailLeft >= currentScrollLeft && 
                     (thumbnailLeft + thumbnailWidth) <= (currentScrollLeft + galleryWidth);
    
    if (!isVisible || Math.abs(currentScrollLeft - targetScrollLeft) > 10) {
      thumbnailGallery.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductGallery();
});

// Initialize when Shopify section is loaded
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.gallery-style-slider, .gallery-style-carousel, .gallery-style-masonry')) {
    new ProductGallery();
  }
});
